module.exports = __webpack_public_path__ + "static/media/icons_Bilan libre.44c7fa30.svg";